import { Article, Category, Tag } from '../utils/schema';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { APP_URL } = publicRuntimeConfig;

export const articleUrl = (article: Article) =>
  `${APP_URL}/${article.category.slug}/${article.slug}/`;

export const categoryUrl = (category?: Category) =>
  `${APP_URL}/${category ? `category/${category.slug}/` : ''}`;

export const tagUrl = (tag: Tag) => `${APP_URL}/tag/${tag.slug}/`;
